<script>
    import eventProxyMixin from "./Mixins/eventProxy";
    
    export default {
        name: 'drag-and-drop-draggable',
        mixins: [eventProxyMixin],
        created() {
            const vm = this;
            
            const dragOptions = {
                start: vm.createEventProxy('start'),
                drag: vm.createEventProxy('drag'),
                stop: vm.createEventProxy('stop')
            };
            
            if(vm.containment){
                dragOptions.containment = vm.containment;
            }
            
            //The element needs to be rendered before we can make it draggable
            vm.$nextTick(() => {
                vm.jsPlumbInstance.draggable(
                    [vm.$el], 
                    dragOptions
                );
            });
        },
        render(createElement, context) {
            return this.$slots.default;
        },
        props: {
            jsPlumbInstance: {
                type: Object,
                required: true
            },
            
            //Part of DragOptions
            /*
                containment?: Boolean
                start?: (params:DragEventCallbackOptions) => void;
                drag?: (params:DragEventCallbackOptions) => void;
                stop?: (params:DragEventCallbackOptions) => void;
             */
            containment: {
                type: Boolean,
                required: false
            }
        }
    }
</script>

<style scoped>
    * {
        position: absolute;
    }
</style>